import Image from "next/image";
import BasicBlock from "../shared/basic-block";
import { CDN_URL } from "@/consts";

const steps = [
  {
    title: "Upload your video",
    description: "Use any file, or a YouTube/TikTok link.",
    image: `${CDN_URL}/landing/steps/step1.png`,
  },
  {
    title: "Select Subtitle style",
    description: "Choose from 15+ viral styles.",
    image: `${CDN_URL}/landing/steps/step2.png`,
  },
  {
    title: "Generate Video",
    description: "Watch it generate a video in seconds.",
    image: `${CDN_URL}/landing/steps/step3.png`,
  },
];

const StepsSection = () => {
  return (
    <BasicBlock
      header="Workflows To Go Viral"
      mobileHeader="3 Step Workflow"
      subHeader="Example: See how to generate a streamer blurred clip"
      customCTA={{ text: "Make an account", href: "https://crayo.ai/signup" }}
    >
      <div className="grid w-full grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {steps.map((step, index) => (
          <div key={index} className={`flex w-full flex-col rounded-xl border border-[#D7DBEA]`}>
            <Image
              src={step.image}
              alt={step.title}
              width={782}
              height={476}
              draggable={false}
              className="w-full rounded-t-xl"
            />
            <div className="flex select-none flex-col items-start justify-center gap-2 px-4 py-6">
              <h2 className="flex items-center gap-2 text-xl">
                <span className="flex min-h-[2em] min-w-[2em] items-center justify-center rounded-full bg-[#335CFF] text-xs text-white">
                  {index + 1}
                </span>{" "}
                {step.title}
              </h2>
              <p className="text-base text-[#616885]">{step.description}</p>
            </div>
          </div>
        ))}
      </div>
    </BasicBlock>
  );
};

export default StepsSection;
